// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientRegistrationField_container__uAEK1"};